import { useState } from 'react'
import "./Modal.css"
import closeIcon from '../../assets/iconos/cerrar.png'

/* Props obligatorias: showModal, setShowModal, children.
Lo demas es para estilos y tiene valores default */
const DialogModal = ({ showModal, setShowModal, showClose, centerVertically, padding, contentWidth, children, styles }) => {
    return (
        <div className={!showModal ? "modal-bg-hidden" : "modal-bg"}>

            <div className={"modal-container"} style={{alignItems: centerVertically === false  ? "start" : "center" , padding, ...styles?.container}}>
                {showClose !== false && <img style={{...styles?.icon}} src={closeIcon} alt="close icon" className="chat-icon setpointer sethoverdark modal-container-close-btn" onClick={() => setShowModal(false)} />}
                <div className='modal-content' style={{margin: !centerVertically && "unset", width: contentWidth, ...styles?.content}}>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default DialogModal